import { useState } from "react";
import { Dialog, IconButton } from "@educaplay/core";
import classes from "./ImageComponent.module.scss";
import { Search } from "@educaplay/core/Icons/Search";

export default function ImageComponent(props) {
  const { data } = props;
  const [open, setOpen] = useState(false);

  const clickImage = (e) => {
    e.stopPropagation();
    setOpen(true);
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={(e) => {
          e.stopPropagation();
          setOpen(false);
        }}
        variant="lightbox"
      >
        <img src={data.src} alt="" />
      </Dialog>
      <div className={classes.imageContainer}>
        <div className={classes.container}>
          <img className={classes.image} src={data.src} />
          <IconButton
            icon={<Search />}
            onClick={clickImage}
            className={classes.expand}
          />
        </div>
      </div>
    </>
  );
}
